<template>
  <div class="content-wrapper">
    <SendGiftMenu
      :header="headerTitle"
      back-to="AddRecipient"
      :display-stepper="true"
    />

    <!-- Cards section  here -->
    <div class="select-arena">
      <card
        @handleCard="handleCard"
        @updateQuantity="updateQuantity"
        @next="nextPage"
      />
    </div>

    <!-- Card message here -->
    <div class="form-arena inter" v-if="isPersonalized && cardList.length">
      <p>Card Message</p>
      <form @submit.prevent>
        <div class="form-group mini">
          <select
            class="minimal"
            v-model="selectedTemplateId"
            @change="onSelectedTemplateChange($event)"
          >
            <option disabled selected value="0">Select card template</option>
            <option
              v-for="cardTemplate in cardTemplatesList"
              :key="cardTemplate.id"
              :value="cardTemplate.id"
              >{{ cardTemplate.name }}</option
            >
          </select>
        </div>
        <transition name="fade">
          <div class="form-group template-name-form" v-show="saveTemplate">
            <label for="name">Template name</label>
            <input
              type="text"
              id="name"
              class="form-control"
              v-model="templateName"
            />
          </div>
        </transition>
        <div class="form-group">
          <textarea
            :maxlength="maxCharacters"
            placeholder="Your thoughtful message..."
            v-model="message"
          />
          <span class="characters-count"
            >{{ charactersLeft }} characters left</span
          >
        </div>
        <div class="form-group flex-center">
          <label class="checkbox-container transparent">
            <p>Save as new a template</p>
            <input type="checkbox" v-model="saveTemplate" />
            <span class="checkmark"></span>
          </label>
        </div>
      </form>
    </div>

    <!-- Button here -->
    <div class="button-area">
      <button
        class="button-gemnote button-gemnote--small"
        @click="continueToRecipient"
        :class="{
          'button-gemnote--disabled': isCreatingOrder
        }"
        :disabled="isCreatingOrder"
      >
        <span>{{ isEditing ? 'Save' : 'Next' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  layouts,
  storeModules,
  cardStates,
  scrollPageToTop,
  isPersonalizedCard,
  isCard
} from '../../helpers'
import Util from '../../mixins/Util'
import store from '../../store'
import i18n from '../../internatinalization/i18n'
// Components
import Card from '../Universal/ChooseCard'
import SendGiftMenu from '@/components/SendGiftMenu'
export default {
  name: 'CardMessage',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  mixins: [Util],

  components: {
    SendGiftMenu,
    Card
  },

  data() {
    return {
      saveTemplate: false,
      templateName: '',
      activeCard: null,
      isPersonalized: false,
      quantity: 1,
      selectedCard: {}
    }
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.dispatch('cardTemplate/getCardTemplates', {})
    this.$store.dispatch('cardTemplate/getCards')
    scrollPageToTop()
  },

  computed: {
    ...mapGetters('order', ['charactersLeft']),
    personalizedCard() {
      const card = this.activeCard.attributes
      const tagList = isPersonalizedCard(card && card.tagList)
      const typeList = isPersonalizedCard(card && card.typeList)
      return tagList || typeList
    },
    isEditing() {
      return parseInt(this.$route.query.editing || '') === 1
    },

    isSalesForceConnected() {
      return this.$store.getters['integration/isSalesForceConnected']
    },

    headerTitle() {
      return this.isEditing ? 'Edit card' : 'Add  a card'
    },
    message: {
      get() {
        return this.$store.state.order.cardMessage
      },
      set(value) {
        this.$store.dispatch('order/setCardMessage', value)
      }
    },
    selectedTemplateId: {
      get() {
        return this.$store.state.order.selectedTemplateId
      },
      set(value) {
        this.$store.dispatch('order/setSelectedTemplate', value)
      }
    },
    ...mapState({
      maxCharacters: state => state.order.maxCharacters,
      cardTemplatesList: state => state.cardTemplate.cardTemplatesList,
      cardList: state => state.cardTemplate.cardList,
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      creatingRecipient: state => state.recipient.creatingRecipient,
      selectedOption: state => state.recipient.selectedRecipientList,
      recipientType: state => state.recipient.recipientType,
      isCreatingOrder: state => state.order.isCreatingOrder,
      selectedRecipientId: state => state.order.selectedRecipientId
    })
  },

  methods: {
    updateQuantity(value) {
      this.quantity = value
    },
    handleCard(card) {
      this.activeCard = card
      if (this.activeCard.id == cardStates.NO_CARD) {
        return (this.isPersonalized = false)
      }
      this.personalizedCard
        ? (this.isPersonalized = true)
        : (this.isPersonalized = false)
      const product = {
        attributes: card.attributes,
        id: card.id,
        quantity: 1,
        selectedVariant: {
          id: card.id,
          price: card.attributes.price,
          imageURL: card.image && card.image.url,
          displayName: card.attributes.displayName,
          inventoriesCount: card.inventoryCount
        }
      }
      this.selectedCard = product
    },
    async continueToRecipient() {
      if (!this.cardList.length) {
        await this.removeUnusedCards()
        return this.nextPage()
      }
      if (!this.activeCard) {
        return this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: [i18n.t('validations.empty-card')]
        })
      }
      if (this.activeCard.id == cardStates.NO_CARD) {
        this.message = ''
      }
      if (this.activeCard.id != cardStates.NO_CARD) {
        if (this.personalizedCard) {
          // Check for empty message
          if (!this.message) {
            return this.$store.dispatch('notification/pushNotification', {
              type: 'error',
              messages: [i18n.t('validations.blank-template-body')]
            })
          }

          // Check for Blank space as First Character
          if (/^\s/.test(this.message)) {
            return this.$store.dispatch('notification/pushNotification', {
              type: 'error',
              messages: [i18n.t('validations.blank-space')]
            })
          }
        } else {
          this.message = ''
        }
        // Add Product to cart if not present
        const productAlreadyCart = this.shoppingBagProducts.some(
          product => product.id === this.selectedCard.id
        )

        if (!productAlreadyCart) {
          // Remove any unused card from cart
          await this.removeUnusedCards(this.selectedCard.id)
          // Add new  card
          this.selectedCard.quantity = this.quantity
          await this.$store.dispatch(
            'order/addCardToCartToCart',
            this.selectedCard
          )
        }
      } else {
        // This checks if there is an existing card when 'no card' is selected and then moves to remove it or just continue
        let presentCard = this.shoppingBagProducts.filter(prd =>
          prd && prd.attributes && prd.attributes.tagList
            ? isCard(prd.attributes.tagList)
            : []
        )
        if (presentCard.length) {
          await this.removeUnusedCards()
        }
      }

      // Check for save template action
      if (this.saveTemplate) {
        const check = await this.handleSaveTemplateErrors()
        if (!check.length) {
          await this.$store.dispatch('cardTemplate/addCardTemplate', {
            name: this.templateName,
            message: this.message
          })
        } else {
          return
        }
      }
      this.nextPage()
    },
    handleSaveTemplateErrors() {
      let errors = []
      if (!this.templateName) {
        errors.push(i18n.t('validations.blank-template-name'))
      }

      if (!this.message) {
        errors.push(i18n.t('validations.blank-template-body'))
      }

      if (errors.length) {
        this.$store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }

      return errors
    },
    onSelectedTemplateChange(event) {
      if (event.target.value > 0) {
        let cardTemplate = this.cardTemplatesList.find(
          template => template.id === event.target.value
        )
        return this.$store.dispatch(
          'order/setCardMessage',
          cardTemplate.message
        )
      }
      return (this.message = '')
    },
    async removeUnusedCards(usedCardId) {
      let cachedCard = {}
      const unusedCardsInCart = this.shoppingBagProducts.filter(
        product =>
          product.attributes &&
          isCard(product.attributes.tagList) &&
          product.id !== usedCardId
      )
      const cardStr = localStorage.getItem('selectedCard')
      if (cardStr) {
        cachedCard = JSON.parse(cardStr)
      }
      for (const card of unusedCardsInCart) {
        if (card.id === cachedCard.id) localStorage.removeItem('selectedCard')

        await this.$store.dispatch('order/removeShoppingBagItem', card)
      }
    },
    nextPage() {
      if (this.recipientType === 'single') {
        this.handleSingleOrder()
      } else {
        this.handleMultipleOrder()
      }
    },

    handleSingleOrder() {
      return this.$store.dispatch('order/createOrder', {
        recipientId: this.selectedRecipientId
      })
    },
    handleMultipleOrder() {
      if (this.isEditing) {
        this.$router.push({ name: 'ConfirmOrder' })
      } else {
        const route = this.isSalesForceConnected
          ? 'LinkSalesForceRecord'
          : 'ConfirmOrder'
        this.$router.push({ name: route })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.select-arena {
  margin-top: 35px;
  p {
    text-align: left;
    color: #25282a;
    font-weight: bold;
  }
}

.checkbox-container {
  p {
    font-size: 0.813rem;
    margin-left: 32px;
  }
}
.button-area {
  border-top: 1px solid #dfdad2;
  margin-top: 20px;
  padding-top: 40px;
  display: flex;
  justify-content: center !important;
  @media (max-width: 575.98px) {
    justify-content: center;
    margin-top: 10px;
  }
  @media (min-width: 576px) and (max-width: 767.98px) {
    justify-content: center;
    margin-top: 10px;
  }
  .button-gemnote--small {
    padding: 0 2rem !important;
    height: 3rem !important;
    @media (max-width: 575.98px) {
      width: 100%;
    }
    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
    }
  }
}
.form-arena {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  @media (max-width: 575.98px) {
    flex-wrap: wrap;
  }
  @media (min-width: 576px) and (max-width: 767.98px) {
    flex-wrap: wrap;
  }
  p {
    color: #24292c;
    font-weight: bold;
    @media (max-width: 575.98px) {
      padding-bottom: 20px;
    }
    @media (min-width: 576px) and (max-width: 767.98px) {
      padding-bottom: 20px;
    }
  }
  .form-group.mini {
    width: 50%;
    @media (max-width: 575.98px) {
      width: 100%;
    }
    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
    }
    select {
      background: $dark-gray;
      font-size: 0.813rem;
      background-image: url('../../assets/dropdownarrow.svg');
      background-repeat: no-repeat;
      background-position: calc(100% - 14px) calc(1em + 7px),
        calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
    }
  }
}
.characters-count {
  color: #9b9b9b;
  font-size: 0.688rem;
  margin: 0.5rem 0rem;
  float: right;
}
.button-gemnote--big {
  display: block;
}
form {
  width: 83%;
  .form-group {
    &.template-name-form {
      display: grid;
      grid-template-columns: 25% 1fr;
      align-items: center;
      width: 70%;

      @media (max-width: 767.98px) {
        grid-template-columns: 25% 1fr;
        width: 100%;
      }

      label {
        margin-bottom: 0px;
        text-align: left;
      }
    }
    textarea {
      font-size: 13px;
      font-family: $inter;
      border: 1px solid #a09c95;
      background: inherit;
      padding: 20px 20px;
      height: 150px;
      resize: none;

      &::placeholder {
        font-size: 0.813rem;
      }
    }
    .form-control {
      font-size: 0.813rem;
    }
    label {
      font-size: 0.813rem;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@media screen and (max-width: 1450px) and (min-width: 350px) {
  .content-wrapper {
    padding-right: 0;
  }
}
@media (max-width: 1100px) {
  form {
    width: 100%;
  }
}
</style>
